export default __webpack_public_path__ + "static/media/Night_Owl_Security_Camera_banner.98f70943.jpg";